const brand = {
  "100": "#F4F5F7",
  "200": "#F4F6FF",
  "300": "#e1e7ff",
  "400": "#515BA5",
  "500": "#3A3879",
  "600": "#110a4e",
};
const neutrals = {
  "0": "#FFFFFF",
  "10": "#FAFBFC",
  "15": "#F8F9FA",
  "20": "#F4F5F7",
  "30": "#EBECF0",
  "40": "#DFE1E6",
  "50": "#C1C7D0",
  "60": "#B3BAC5",
  "70": "#A5ADBA",
  "80": "#97A0AF",
  "90": "#8993A4",
  "100": "#7A869A",
  "200": "#6B778C",
  "300": "#5E6C84",
  "400": "#505F79",
  "500": "#42526E",
  "600": "#344563",
  "700": "#0F172A",
  "800": "#172B4D",
  "900": "#0F172A",
};
const accent = {
  turquoise: {
    "100": "#C5ECF9",
    "200": "#95F1EB",
    "300": "#0BDBCE",
    "400": "#007F9C",
    "500": "#09736D",
  },
  green: {
    "100": "#E1F5DC",
    "200": "#B4EDB0",
    "300": "#76DE6D",
    "400": "#34A44A",
    "500": "#177335",
  },
  orange: {
    "100": "#FFECC6",
    "200": "#FBD892",
    "300": "#F2C464",
    "400": "#785926",
    "500": "#9E4200",
  },
  red: {
    "100": "#FFEEEE",
    "200": "#FFDADB",
    "300": "#f48b90",
    "400": "#B84C56",
    "500": "#a03b46",
    "600": "#8e030f",
  },
  yellow: {
    "100": "#FCFFD6",
    "200": "#FFFFA6",
    "300": "#FFF03F",
  },
};
const text = {
  white: "#FFFFFF",
  paragraph: {
    light: "#6B778C",
    regular: "#42526E",
  },
  title: "#051839",
  link: {
    default: "#3A3879",
    hover: "#3A3879",
  },
};
const info = {
  background: "#C5ECF9",
  icon: "#007F9C",
  title: "#004F62",
  paragraph: "#004F62",
  link: "#3A3879",
};
const success = {
  background: "#CEEDDD",
  icon: "#268460",
  title: "#00563A",
  paragraph: "#00563A",
  plainText: "#1B6F50",
  link: "#3A3879",
};
const warning = {
  background: "#FFECC6",
  icon: "#785926",
  title: "#564119",
  paragraph: "#564119",
  plainText: "#785926",
  link: "#3A3879",
};
const error = {
  background: "#FFDADB",
  icon: "#B84C56",
  title: "#7C2731",
  paragraph: "#7C2731",
  plainText: "#A03B46",
  link: "#3A3879",
};
const form = {
  disabled: {
    background: neutrals["30"],
    text: neutrals["600"],
  },
  outline: {
    light: "#C1C7D0",
    dark: "#7A869A",
  },
};
const colors = {
  brand,
  neutrals,
  accent,
  info,
  success,
  warning,
  error,
  form,
  text,
};

export default colors;
